import { updateLinksAttributes } from '../utils/handleAttributes';

export default function buyTicketButton() {
  const widgetName = 'buyTicketButton';
  const widgetOpts = buyTicketButtonOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createbuyTicketButton(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function createbuyTicketButton(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $item = $(this);

      if (URL == null || URL === '') {
        $item.remove();
      } else {
        $item.replaceWith(
          `<a href="${URL}" class="button header-btn" ${updateLinksAttributes(URL, Title)}>${Title}</a>`,
        );
      }
    });
  }
}
